import React from 'react';
import {connect} from 'react-redux';
import {defineMessages, FormattedMessage, FormattedHTMLMessage} from 'react-intl';

import {
    cancelPasswordRecovery as cancelPasswordRecoveryAction,
    recoverPassword as recoverPasswordAction,
    recoverPasswordViaPhone as recoverPasswordViaPhoneAction
} from 'actions/creators/PasswordRecovery';

import * as PasswordRecoveryStates from 'constants/PasswordRecoveryState';
import PasswordRecoveryViaPhone from './PasswordRecoverViaPhone.jsx';

const messages = defineMessages({
    recovery: {
        id: 'password_recovery.title',
        defaultMessage: 'Восстановление учетной записи'
    },
    passwordSentTo: {
        id: 'password_recovery.sent_to',
        defaultMessage: 'Новый пароль был выслан на'
    },
    passwordSentRepeatedly: {
        id: 'password_recovery.sent_repeatedly',
        defaultMessage: 'Мы многократно отправили информацию о восстановлении пароля. В целях безопасности, пожалуйста, обратитесь в службу поддержки.'
    },
    smsExceeded: {
        id: 'password_recovery.sms_exceeded',
        defaultMessage: 'Мы дважды выслали на Ваш номер сообщение для восстановления пароля. Пожалуйста, дождитесь СМС, либо обратитесь в службу поддержки.'
    },
    deliveryCondition: {
        id: 'password_recovery.delivery_condition',
        defaultMessage: 'Если в течении пяти вы не получите от нас письма, то проверьте папку "Спам"'
    },
    support: {
        id: 'password_recovery.support',
        defaultMessage: 'В противном случае, свяжитесь со службой поддержки клиентов через онлайн-чат'
    },
    registrationRequisite: {
        id: 'password_recovery.registration_requisite',
        defaultMessage: 'Укажите логин, номер счета, е-майл или номер телефона (в формате {mask}), который вы использовали при регистрации на сайте'
    },
    requisite: {
        id: 'password_recovery.requisite',
        defaultMessage: 'Реквизит'
    },
    recoverTitle: {
        id: 'password_recovery.recover_title',
        defaultMessage: 'Восстановить'
    },
    passwordSentToPhone: {
        id: 'password_recovery.sent_via_sms',
        defaultMessage: 'Пароль выслан на номер <strong>{phone}</strong>'
    },
    supportPhone: {
        id: 'password_recovery.support_phone',
        defaultMessage: 'Если в течении нескольких минут вы не получите SMS, свяжитесь со службой поддержки клиентов через онлайн-чат'
    },
    passwordChanged: {
        id: 'create-password.password_changed',
        defaultMessage: 'Пароль изменен'
    },
});

class PasswordRecovery extends React.Component {
    static propTypes = {
        createPasswordErrorCode: React.PropTypes.any,
        errorCode: React.PropTypes.number,
        email: React.PropTypes.string,
        phone: React.PropTypes.string,
        recoveryState: React.PropTypes.number.isRequired,
        cancelPasswordRecoveryAction: React.PropTypes.func.isRequired,
        recoverPasswordViaPhoneAction: React.PropTypes.func.isRequired,
        recoverPasswordAction: React.PropTypes.func.isRequired
    };

    static _successEmail(email) {
        return (
            <div className="modal--auth-recover__success">
                <p className="plain-text__paragraph modal--auth-recover__title">
                    <span className="modal--auth-recover__title__span">
                        <FormattedHTMLMessage {...messages.passwordSentTo} values={{email}}/>
                    </span>
                </p>

                <p className="plain-text__paragraph">
                    <FormattedMessage {...messages.deliveryCondition} />
                </p>

                <p className="plain-text__paragraph">
                    <FormattedMessage {...messages.support} />
                </p>
            </div>
        );
    }

    static _successPhone(recoverPassword, errorCode, state) {
        let message;
        if (errorCode === -100 || errorCode == -500) {
            message = (
                <div className="error-message" style={{marginLeft: '175px', marginBottom: '15px'}}>
                    <FormattedMessage id="password_recovery.errors.internal_error" />
                </div>
            );
        }

        if (state === 0) {
            return (
                <p className="plain-text__paragraph">
                    <FormattedMessage {...messages.passwordChanged} />
                </p>
            );
        }

        return (
            <div className="modal--auth-recover__success">
                {message}
                <PasswordRecoveryViaPhone submitAction={recoverPassword} />
            </div>
        );
    }

    static _init(errorCode, onRecoverClick, email, emailRecover, phoneRecover, countryCode) {
        let message;
        let mask = '77011234567'
        if (countryCode === 'UZ') mask = '998011234567'
        if (countryCode === 'KG') mask = '996011234567'

        if (errorCode === -2) {
            message = (<div className="error-message">
                <FormattedMessage id="password_recovery.errors.invalid_credentials" />
            </div>);
        } else if (errorCode === -3 || errorCode === -4) {
            if (emailRecover) {
                message = (<div className="error-message">
                    <FormattedHTMLMessage {...messages.passwordSentRepeatedly} values={{email}}/>
                </div>);
            } else if (phoneRecover) {
                message = (<div className="error-message">
                    <FormattedHTMLMessage {...messages.smsExceeded} values={{email}}/>
                </div>);
            }
        }
        else if (errorCode === -5) {
            message = (<div className="error-message">
                <FormattedMessage id="password_recovery.errors.blocked" />
            </div>);
        }
        else if (errorCode === -10000 || errorCode === -100) {
            message = (<div className="error-message">
                <FormattedMessage id="password_recovery.errors.internal_error" />
            </div>);
        }

        return (
            <form className="login--form form">
                <p className="plain-text__paragraph">
                    <FormattedMessage {...messages.registrationRequisite} values={{mask}} />
                </p>
                {message}
                <div className="login--form__row form__row">
                    <input ref="requisite" className="login--form__control form__control" style={{marginLeft: 175}}/>
                </div>
                <div className="login--form__row form__row">
                    <button className="login--form__btn login--form__btn__js form__btn"
                            onClick={onRecoverClick}>
                        <FormattedMessage {...messages.recoverTitle} />
                    </button>
                </div>
            </form>
        );
    }

    constructor(props) {
        super(props);

        this._handleCloseClick = this._handleCloseClick.bind(this);
        this._handleRecoverClick = this._handleRecoverClick.bind(this);
        this._recoverPassword = this._recoverPassword.bind(this);

        this.state = {
            requisite: '',
            emailRecover: false,
            phoneRecover: false
        };
    }

    componentDidMount() {
        this.refs.requisite.focus();
    }

    _handleCloseClick(e) {
        e.preventDefault();
        this.props.cancelPasswordRecoveryAction();
    }

    _handleRecoverClick(e) {
        e.preventDefault();

        let emailRecover = false;
        let phoneRecover = false;
        const requisiteVal = this.refs.requisite.value;
        if (requisiteVal) {
            const phone = requisiteVal.substring(1);
            if (requisiteVal[0] === '+' && /^\d+$/.test(phone)) {
                this.props.recoverPasswordAction({requisite: phone});
                phoneRecover = true;
            } else {
                this.props.recoverPasswordAction({requisite: requisiteVal});
                emailRecover = true;
            }
        }

        this.setState({
            requisite: requisiteVal,
            emailRecover,
            phoneRecover
        });
    }

    _recoverPassword(values) {
        this.props.recoverPasswordViaPhoneAction(values);
    }

    render() {
        const {errorCode, email, phone, recoveryState, createPasswordErrorCode, createPasswordState, countryCode} = this.props;
        const {requisite, emailRecover, phoneRecover} = this.state;

        return (
            <div className="modal modal--auth modal--auth-recover modal__visible ">
                <div className="modal--dialog">
                    <div className="modal--header">
                        <div className="header-inner--logotype__link"/>
                        <div className="header-inner__title">
                            <FormattedMessage {...messages.recovery} />
                        </div>
                        <button className="modal__close modal__close__green modal__close__js"
                                onClick={this._handleCloseClick}/>
                    </div>
                    <div className="modal--content">
                        <div className="modal--content__wrapper">
                            {!errorCode && email && recoveryState === PasswordRecoveryStates.FINISH &&
                            PasswordRecovery._successEmail(email)}
                            {!errorCode && phone && recoveryState === PasswordRecoveryStates.FINISH &&
                            PasswordRecovery._successPhone(this._recoverPassword, createPasswordErrorCode, createPasswordState)}
                            {!errorCode && phone && createPasswordState === 0 &&
                            PasswordRecovery._successPhone(this._recoverPassword, createPasswordErrorCode, createPasswordState)}
                            {!errorCode && phone && createPasswordErrorCode &&
                            PasswordRecovery._successPhone(this._recoverPassword, createPasswordErrorCode, createPasswordState)}
                            {(errorCode || recoveryState === PasswordRecoveryStates.INIT) &&
                            PasswordRecovery._init(errorCode, this._handleRecoverClick, requisite, emailRecover, phoneRecover, countryCode)}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function select(state) {
    const errorCode = state.passwordRecovery.get('errorCode');
    const email = state.passwordRecovery.get('email');
    const phone = state.passwordRecovery.get('phone');
    const recoveryState = state.passwordRecovery.get('state');
    const createPasswordErrorCode = state.passwordRecovery.get('createPasswordErrorCode');
    const createPasswordState = state.passwordRecovery.get('createPasswordState');
    const countryCode = state.application.get('countryCode');

    return {
        errorCode,
        email,
        phone,
        recoveryState,
        createPasswordErrorCode,
        createPasswordState,
        countryCode,
    };
}

export default connect(select, {cancelPasswordRecoveryAction, recoverPasswordAction, recoverPasswordViaPhoneAction})(PasswordRecovery);



// WEBPACK FOOTER //
// ./js/sport-betting/components/PasswordRecovery.jsx